<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off" #form>
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Mã</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="code" name="maCS" type="text" placeholder="Nhập mã" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Chế độ tham gia giáo dục người khuyết tật</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="name" name="tenCs" type="text" placeholder="Nhập chế độ tham gia giáo dục người khuyết tật">
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS">Số thứ tự</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="displayOrder" name="tenCs" type="text" placeholder="Nhập số thứ tự">
        </nz-form-control>
        </nz-form-item >
      </div>
      <!-- <div nz-col nzSm="24" nzMd="24">
        <div nz-row>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn phân hệ là GDHN</label></nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn nhập số phòng hỗ trợ là GDHN</label></nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn cấp trực thuộc là GDHN</label></nz-form-item>
          </div>
        </div>
      </div> -->
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>